import React from 'react';
import PropTypes from 'prop-types';
import { I18nUtils } from '../../../i18n/I18nUtils';
import CollapseCard from '../../shared/components/CollapseCard';
import ActiveLabel from '../../shared/components/ActiveLabel';

export default class WorkerInfoCard extends React.Component {

    render() {
        const {
            dni,
            name,
            position,
            last_name,
            worker_state,
            document_schema,
        } = this.props.worker;

        let title = dni + ' - ';
        title += name + ' ' + last_name;
        title += ( document_schema ? ' - ' + document_schema.name : ' ' );
        title += ( position ? ' - ' + position : ' ' );

        return (
            <CollapseCard
                title={title}
                collapsed={false}
            >
                <div className="info-card-content">
                    <div>
                        <b>{I18nUtils.tr('TR_ESTADO')}: </b>
                        <span>{worker_state ? <ActiveLabel state={worker_state}/> : '-'}</span>
                    </div>
                </div>
            </CollapseCard>
        );
    }
}

WorkerInfoCard.propTypes = {
    worker: PropTypes.shape({
        document_schema_id: PropTypes.number.isRequired,
        dni: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        last_name: PropTypes.string,
        worker_state_id: PropTypes.number.isRequired,
    }),
};

WorkerInfoCard.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/worker/components/WorkerInfoCard.js